import axios from "axios";

import type { GetWeatherData } from "./types";

export const fetchWeatherData = async () => {
  const url = new URL("https://assets.i-scmp.com/weather/data.json");
  const resp = await axios.get<GetWeatherData>(url.toString());
  return resp?.data;
};
